async function getCookie(id) {

    let value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
    return value ? unescape(value[2]) : null;
 
 }



async function CrearMatrizConResultados(Preguntas){

    var Resultados = {};

    

    var cookieReferido = await getCookie("id_agente_alg");

    if (cookieReferido != "")
    {

        Resultados["referido"] = cookieReferido;

    }


    for (let Pregunta of Preguntas)
    {
        
        let respuesta = Pregunta["response"];

        if (respuesta != null)
        {

            if (Pregunta["code"])
            {
    
                if(Pregunta["parentCode"])
                {
    
                    let codigo = Pregunta["parentCode"];

                    if (Pregunta["allresponses"])
                    {


                        var response = {

                            response: respuesta,
                            allresponses: Pregunta["allresponses"]

                        }

                    } else {


                        if (Pregunta["tipo"] == "Pricing")
                        {


                            var response = {

                                response: respuesta,
                                price: Pregunta["price"],
                                periodo: Pregunta["periodo"],
                                products: Pregunta["products"],
                                count: Pregunta["count"]

                            }


                        } else {

                            var response = {

                                response: respuesta
        
                            }


                        }





                    }



    
                    if (Array.isArray(Resultados[codigo]))
                    {
    
                        Resultados[codigo].push(response);
    
                    } else {
    
    
                        Resultados[codigo] = [];
                        Resultados[codigo].push(response);
                        
    
                    }
    
    
                } else {

                    if (Pregunta["allresponses"])
                    {


                        var response = {

                            response: respuesta,
                            allresponses: Pregunta["allresponses"]

                        }

                    } else {



                        if (Pregunta["tipo"] == "Pricing")
                        {


                            var response = {

                                response: respuesta,
                                price: Pregunta["price"],
                                periodo: Pregunta["periodo"],
                                products: Pregunta["products"],
                                count: Pregunta["count"]
        
                            }


                        } else {

                            var response = {

                                response: respuesta
        
                            }


                        }


                    }

    
                    let codigo = Pregunta["code"];
    
                    Resultados[codigo] = response;
    
    
    
                }
    
    
            }

        }

    
    }

    return Resultados;


}


async function EnviarSolicitud(url, resultados){

    var axios = require("axios");

    try {

        let Datos = await axios(
            {
                method: 'post',
                url: url,
                data: resultados,
                config: { headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json' 
                  }}
            }
        );

        return Datos.data;
        
    } catch (error) {

        let retorno = {"status" : "KO", "message" : error};
        return retorno;
        
    }

}






function quitarElementoArray(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
}

exports.CrearMatrizConResultados = CrearMatrizConResultados;
exports.EnviarSolicitud = EnviarSolicitud;
exports.quitarElementoArray = quitarElementoArray;
exports.getCookie = getCookie;